import request from '@/utils/request'

// 设备详情的数据展示
export function goodsApplyCheck() {
  return request({
    url: '/wechat/item/receiving/record/purview/check',
    method: 'GET'
  })
}

// 校验是否有可选择的业务流程
export const processCheck = () => {
  return request({
    url: '/wechat/item/receiving/record/process/check',
    method: 'GET'
  })
}
// 获取可选部门
export const getDeptList = () => {
  return request({
    url: '/wechat/home/dept/list',
    method: 'GET'
  })
}
// 校验业务流程是否可用
export function checkFlowAble(processId) {
  return request({
    url: `/wechat/home/isAvailable?processId=${processId}`,
    method: "GET",
  });
}
// 获取物品流程
export const getGoodsProcess = (params) => {
  return request({
    url: '/wechat/item/receiving/record/flowable/list',
    method: 'GET',
    params
  })
}

// 申请时用到的物品列表
export const getGoodsNameList = (params) => {
  return request({
    url: '/wechat/item/itemList',
    method: 'GET',
    params
  })
}
// 提交
export const goodsApply = (data) => {
  return request({
    url: '/wechat/item/receiving/record',
    method: 'POST',
    data
  })
}
export function getProcessDefinitionId(processId) {
  return request({
    url: `/wechat/item/receiving/record/getProcessDefinitionId?processId=${processId}`,
    method: "GET",
  });
}